import { useState } from "react";
import { ChevronDown, ChevronRight, Layers } from "lucide-react";

export const PrezzarioTree = ({ tree, selection, onSelect }) => {
  const [open, setOpen] = useState({});
  const toggle = (k) => setOpen((s) => ({ ...s, [k]: !s[k] }));
  const isSel = (m, c, s) => selection.macro === m && (selection.category || "") === (c || "") && (selection.subcategory || "") === (s || "");

  if (!tree.length) return <p className="text-xs text-slate-400 p-3">Nessun prezzario caricato.</p>;

  return (
    <nav className="text-sm" data-testid="prezzario-tree">
      <button onClick={() => onSelect({})} data-testid="tree-all"
        className={`w-full text-left px-3 py-2 rounded-lg flex items-center gap-2 ${!selection.macro ? "bg-orange-50 text-orange-700 font-semibold" : "text-slate-600 hover:bg-slate-50"}`}>
        <Layers className="w-4 h-4" /> Tutte le voci
      </button>
      {tree.map((m) => (
        <div key={m.name} className="mt-1">
          <div className="flex items-center">
            <button onClick={() => toggle(m.name)} className="p-1 text-slate-400 hover:text-slate-700" data-testid={`tree-toggle-${m.name}`}>
              {open[m.name] ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
            </button>
            <button onClick={() => { onSelect({ macro: m.name }); setOpen((s) => ({ ...s, [m.name]: true })); }} data-testid={`tree-macro-${m.name}`}
              className={`flex-1 text-left px-2 py-1.5 rounded-lg text-xs font-display font-bold uppercase tracking-wide truncate ${isSel(m.name) ? "bg-orange-50 text-orange-700" : "text-slate-800 hover:bg-slate-50"}`}
              title={m.name}>
              {m.name} <span className="font-mono font-normal text-slate-400">{m.count}</span>
            </button>
          </div>
          {open[m.name] && (
            <div className="ml-5 border-l border-slate-200 pl-1">
              {m.categories.map((c) => {
                const ck = `${m.name}|${c.name}`;
                const hasSub = c.subcategories.length > 0;
                return (
                  <div key={ck}>
                    <div className="flex items-center">
                      {hasSub ? (
                        <button onClick={() => toggle(ck)} className="p-0.5 text-slate-400 hover:text-slate-700">
                          {open[ck] ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
                        </button>
                      ) : <span className="w-4" />}
                      <button onClick={() => { onSelect({ macro: m.name, category: c.name }); if (hasSub) setOpen((s) => ({ ...s, [ck]: true })); }}
                        data-testid={`tree-cat-${c.name}`} title={c.name}
                        className={`flex-1 text-left px-2 py-1 rounded text-xs truncate ${isSel(m.name, c.name) ? "bg-orange-50 text-orange-700 font-semibold" : "text-slate-700 hover:bg-slate-50"}`}>
                        {c.name} <span className="font-mono text-slate-400">{c.count}</span>
                      </button>
                    </div>
                    {open[ck] && hasSub && (
                      <div className="ml-4 border-l border-slate-100 pl-1">
                        {c.subcategories.map((s) => (
                          <button key={s.name} onClick={() => onSelect({ macro: m.name, category: c.name, subcategory: s.name })}
                            data-testid={`tree-sub-${s.name}`} title={s.name}
                            className={`w-full text-left px-2 py-1 rounded text-[11px] truncate ${isSel(m.name, c.name, s.name) ? "bg-orange-50 text-orange-700 font-semibold" : "text-slate-500 hover:bg-slate-50"}`}>
                            {s.name} <span className="font-mono text-slate-400">{s.count}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};
